import { GridFilterCellProps } from "@progress/kendo-react-grid"
import { DropdownFilterCell } from "./DropDownFilterCell"

export const AuditActionFilterCell = (props: GridFilterCellProps) => {
    const filters = [
        { id: "INSERT", name: "INSERT" },
        { id: "UPDATE", name: "UPDATE" },
        { id: "DELETE", name: "DELETE" }] as any[];

    return <DropdownFilterCell
        {...props}
        data={filters}
        defaultItem={""}
        textField={"name"}
    />
}